import React, { Component } from 'react'
// import PropTypes from 'prop-types'
import { IoMdAddCircleOutline } from 'react-icons/io'
import { FaEdit, FaRegPlusSquare } from 'react-icons/fa'
import { cargosService } from '../../_services/cargos.service'
import AsyncSelect from 'react-select';
import CargoFormDialog from '../Cargos/CargoFormDialog'


class AsyncCargoSelect extends Component {

  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      defaultValue: '',
      data: [],
      value: '',
      keyword: '',
      formDialog: false
    };
  }

  // componentWillMount() {
  //   this.getData();
  // }

  getData() {
    // var dto = {
    //   "page": 1,
    //   "pageSize": 10,
    //   "brandName": "",
    //   "categoryTypeIds": []
    // }
    // brandService.getAll(JSON.stringify(dto))
    //   .then((res) => {
    //     console.log(res.data)
    //     let data = res.data.result.map(elm => ({ "label": elm.name, "value": elm.id }))
    //     this.setState({ data: data, loading: false, isSubmitting: false });
    //   }).catch((error) => { console.log(error) });
  };

  handleChange = e => {
    // console.log(e);
    this.setState({ value: e.value, selectedValue: e.value }, () => {
      this.props.onChange(e);
    })
  }

  handleInputChange = (val) => {
    if (val !== undefined && val.length > 0) {
      this.setState({ keyword: val, data: [], loading: true, isSubmitting: false });
      var dto = {
        "keyword": val,
      }


      cargosService.search(JSON.stringify(dto))
        .then((res) => {
          console.log(dto);
          console.log(res.data);


          let data = res.data.map(elm => ({ "label": elm.name + (elm.tel ? " (" + elm.tel + ")" : ''), "value": elm.id }))

          this.setState({ data: data, loading: false, isSubmitting: false });
        })
        .catch((error) => {
          // console.log(error);
          this.setState({ data: [], loading: false, isSubmitting: false })
        });
    }
  }

  componentWillReceiveProps(nextProps) {

    // if (nextProps.data !== this.state.data) {

    //   this.setState({ data: nextProps.data });

    // }

    if (nextProps.value !== this.state.value) {

      this.setState({ value: nextProps.value });

    }

  }

  handleModalHide = (e) => {
    var evt = e || window.event; // IE compatibility
    if (evt.preventDefault) {
      evt.preventDefault();
    }
    this.setState({ formDialog: false });
  }

  handleModalHideAndReload = (e) => {
    this.getData()
    this.setState({ formDialog: false });
  }

  handleCreateCargo = () => {

    this.setState({ formDialog: true });

  }

  handleCreateCargo = () => {

    this.setState({ selectedValue: undefined, formDialog: true });

  }

  handleEditCargo = () => {

    this.setState({ formDialog: true });

  }

  render() {
    const customStyles = {
      control: (provided) => ({
        ...provided,
        background: '#f6f6f6',
        borderRadius: 20,
        boxShadow: 'none',
        border: 'none',
        paddingRight: '12',
        border: 'thin solid #e1e1e1 '
      }),
      noOptionsMessage: (provided) => ({
        ...provided,
        fontSize: '12px'
      }),
      indicatorSeparator: () => ({
        display: 'none'
      }),
    }
    const { loading, data, value, keyword, selectedValue } = this.state;
    const { disabled, required, placeholder, tabIndex, type } = this.props;

    return (
      <>
        <div className="client-select-container">
          <AsyncSelect
            cacheOptions
            tabIndex={tabIndex}
            classNamePrefix="select"
            // loadOptions={this.loadOptions}
            // defaultOptions
            // menuIsOpen={true}
            placeholder={placeholder || ''}
            isDisabled={disabled}
            styles={customStyles}
            options={data}
            onInputChange={this.handleInputChange}
            className={required ? "select required" : "select"}
            value={data ? data.filter(e => e.value === value)[0] : ''}
            onChange={this.handleChange}
            noOptionsMessage={() => ((keyword.length > 0 && (!data || data.length === 0)) ? "نتیجه ای یافت نشد" : "نام یا تلفن باربری را وارد نمایید")}
            loadingMessage={() => "در حال دریافت اطلاعات از سرور"}
            isLoading={loading}
          />
          {selectedValue ?
            <a onClick={() => this.handleEditCargo()}>
              <FaEdit size="24px" />
            </a>
            : ''}
          <a onClick={() => this.handleCreateCargo()}>
            <FaRegPlusSquare size="22px" />
          </a>

        </div>
        <CargoFormDialog
          show={this.state.formDialog}
          id={selectedValue}
          handleModalHide={() => this.handleModalHide()}
          handleModalHideAndReload={() => this.handleModalHideAndReload()}
        />
      </>
    );
  }
}
export default AsyncCargoSelect;
